export default __webpack_public_path__ + "static/media/the-loft-one.12678c9f.jpg";